/* Do NOT modify this file  - Automatically generated */

window.algoliaShopify = {};
algoliaShopify.config = {
    "app_id": "9YQM9X2YLQ",
    "search_api_key": "3f2797495dee6cfa4576d1a4b1a02435",
    "index_prefix": "shopify_prod_b2b_preorder_en_",
    "index_products": true,
    "index_collections": false,
    "index_articles": false,
    "index_pages": false,
    "sort_orders": [
    {
        "key": "recently_ordered_count",
        "title": "Popularity",
        "desc":
        {
            "active": false,
            "title": "Relevant first"
        }
    },
    {
        "key": "published_at",
        "title": "Publication date",
        "asc":
        {
            "active": false,
            "title": "Oldest first"
        }
    },
    {
        "key": "vendor",
        "title": "Vendor",
        "desc":
        {
            "active": false,
            "title": "Vendor Z-A"
        }
    },
    {
        "key": "vendor",
        "title": "Vendor",
        "asc":
        {
            "active": false,
            "title": "Translation missing: en.algolia.sort.vendor"
        }
    },
    {
        "key": "inventory_quantity",
        "title": "Inventory quantity",
        "desc":
        {
            "active": false,
            "title": "Most available"
        }
    },
    {
        "key": "grams",
        "title": "Weight",
        "desc":
        {
            "active": false,
            "title": "Heaviest first"
        }
    },
    {
        "key": "grams",
        "title": "Weight",
        "asc":
        {
            "active": false,
            "title": "Lightest first"
        }
    },
    {
        "key": "title",
        "title": "Name",
        "desc":
        {
            "active": false,
            "title": "Name Z-A"
        }
    },
    {
        "key": "published_at",
        "title": "Publication date",
        "desc":
        {
            "active": true,
            "title": "Newest first"
        }
    },
    {
        "key": "price_ratio",
        "title": "Price ratio",
        "asc":
        {
            "active": false,
            "title": "Deals first"
        }
    },
    {
        "key": "price",
        "title": "Price",
        "asc":
        {
            "active": true,
            "title": "Price, ascending"
        }
    },
    {
        "key": "price",
        "title": "Price",
        "desc":
        {
            "active": true,
            "title": "Price, descending"
        }
    },
    {
        "key": "title",
        "title": "Name",
        "asc":
        {
            "active": false,
            "title": "Name"
        }
    }],
    "facets": [
    {
        "enabled": true,
        "name": "price",
        "title": "Price range",
        "type": "slider",
        "available_types": ["slider"],
        "forgettable": null,
        "searchable": false,
        "refined_first": false
    },
    {
        "enabled": false,
        "name": "price_range",
        "title": "Price range",
        "type": "disjunctive",
        "available_types": ["disjunctive"],
        "forgettable": null,
        "searchable": false,
        "refined_first": false
    },
    {
        "enabled": false,
        "name": "vendor",
        "title": "Vendor",
        "type": "conjunctive",
        "available_types": ["menu", "conjunctive", "disjunctive"],
        "forgettable": null,
        "searchable": false,
        "refined_first": false
    },
    {
        "enabled": false,
        "name": "product_type",
        "title": "Type",
        "type": "conjunctive",
        "available_types": ["menu", "conjunctive", "disjunctive"],
        "forgettable": null,
        "searchable": false,
        "refined_first": false
    },
    {
        "enabled": false,
        "name": "tags",
        "title": "Tags",
        "type": "conjunctive",
        "available_types": ["menu", "conjunctive", "disjunctive"],
        "forgettable": null,
        "searchable": false,
        "refined_first": false
    },
    {
        "enabled": true,
        "name": "named_tags.Season",
        "title": "Season",
        "type": "conjunctive",
        "available_types": ["conjunctive", "disjunctive", "slider"],
        "forgettable": true,
        "searchable": true,
        "refined_first": false
    },
    {
        "enabled": true,
        "name": "named_tags.Serie",
        "title": "Serie",
        "type": "conjunctive",
        "available_types": ["conjunctive", "disjunctive", "slider"],
        "forgettable": true,
        "searchable": true,
        "refined_first": false
    },
    {
        "enabled": true,
        "name": "named_tags.Designer",
        "title": "Designer",
        "type": "conjunctive",
        "available_types": ["conjunctive", "disjunctive", "slider"],
        "forgettable": true,
        "searchable": true,
        "refined_first": false
    },
    {
        "enabled": true,
        "name": "named_tags.Concept",
        "title": "Concept",
        "type": "conjunctive",
        "available_types": ["conjunctive", "disjunctive", "slider"],
        "forgettable": true,
        "searchable": true,
        "refined_first": false
    },
    {
        "enabled": true,
        "name": "named_tags.Room",
        "title": "Room",
        "type": "conjunctive",
        "available_types": ["conjunctive", "disjunctive", "slider"],
        "forgettable": true,
        "searchable": true,
        "refined_first": false
    }],
    "powered_by": true,
    "colors":
    {
        "main": "#333",
        "secondary": "#888",
        "highlight": "#333"
    },
    "autocomplete_enabled": true,
    "autocomplete_debug": false,
    "input_selector": "form[action=\"/search\"] input[type=\"text\"], form[action=\"/search\"] input[type=\"search\"]",
    "products_autocomplete_hits_per_page": 8,
    "collections_autocomplete_hits_per_page": 2,
    "articles_autocomplete_hits_per_page": 2,
    "pages_autocomplete_hits_per_page": 2,
    "instant_search_enabled": true,
    "instant_search_enabled_on_collection": false,
    "results_selector": ".main-content",
    "products_full_results_hits_per_page": 12,
    "collections_full_results_hits_per_page": 10,
    "show_products": false,
    "analytics_enabled": false,
    "collection_id_indexing": true,
    "collection_id_query_rules": false,
    "collection_search_feature_enabled": false,
    "collection_css_selector": ".main-content",
    "collection_facets": null,
    "collection_sort_orders": null,
    "stock_policy": "allow"
};